// Centralised data-testid namespace for the RSV Global Guayaquil site.
export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  brand: "nav-brand-logo",
  inicio: "nav-link-inicio",
  club: "nav-link-club",
  filosofia: "nav-link-filosofia",
  crianza: "nav-link-crianza",
  razas: "nav-link-razas",
  directiva: "nav-link-directiva",
  eventos: "nav-link-eventos",
  contacto: "nav-link-contacto",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  section: "hero-section",
  cta: "hero-cta-button",
  ctaSecondary: "hero-cta-secondary",
};

export const SECTION = {
  club: "section-club",
  filosofia: "section-filosofia",
  crianza: "section-crianza",
  razas: "section-razas",
  directiva: "section-directiva",
  eventos: "section-eventos",
  galeria: "section-galeria",
  contacto: "section-contacto",
};

export const EVENT = {
  filterAll: "evento-filter-all",
  filterProximo: "evento-filter-proximo",
  filterPasado: "evento-filter-pasado",
  row: (id) => `evento-row-${id}`,
};

export const DIRECTIVA = {
  card: (id) => `directiva-card-${id}`,
};

export const CONTACTO = {
  form: "contacto-form",
  nombre: "contacto-input-nombre",
  email: "contacto-input-email",
  asunto: "contacto-input-asunto",
  mensaje: "contacto-input-mensaje",
  submit: "contacto-submit",
  whatsapp: "contacto-whatsapp",
  feedback: "contacto-feedback",
};
